<script setup lang="ts">
import { watchEffect, ref, defineProps } from 'vue';
import { useRouter } from 'vue-router'
import ScheduleList from '../components/ScheduleList.vue'

const { phone } = defineProps(['phone'])
const token = ref('')
const router = useRouter()

watchEffect(async () => {
  const beteToken = localStorage.getItem('bete-token') || ''
  if (!beteToken) {
    return router.push('/login')
  } else {
    token.value = beteToken
  }
})
</script>

<template>
  <ScheduleList v-if="phone && token" :phone="phone" :token="token" />
</template>


